/**
 * LUADA Landing Page – Notrufuhr (landing-notrufuhr.js)
 * Wizard-Formular, Tabs, Sticky CTA, Scroll-Verhalten
 */

(function () {
  'use strict';

  /* ===== TABS ===== */
  function initTabs() {
    var tabButtons = document.querySelectorAll('.lp-tabs__btn');
    var tabPanels = document.querySelectorAll('.lp-tabs__panel');

    if (!tabButtons.length) return;

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab');

        tabButtons.forEach(function (b) {
          b.classList.remove('lp-tabs__btn--active');
          b.setAttribute('aria-selected', 'false');
        });
        tabPanels.forEach(function (p) {
          p.classList.remove('lp-tabs__panel--active');
          p.hidden = true;
        });

        btn.classList.add('lp-tabs__btn--active');
        btn.setAttribute('aria-selected', 'true');

        var panel = document.querySelector('[data-tab-panel="' + target + '"]');
        if (panel) {
          panel.classList.add('lp-tabs__panel--active');
          panel.hidden = false;
        }
      });
    });
  }

  /* ===== WIZARD FORM ===== */
  function initWizard() {
    var form = document.getElementById('lp-lead-form');
    var successEl = document.getElementById('lp-form-success');
    var progressBar = document.getElementById('lp-wizard-progress');
    var currentIndicator = document.getElementById('lp-wizard-current');
    var btnBack = document.getElementById('lp-wizard-back');
    var btnNext = document.getElementById('lp-wizard-next');
    var btnSubmit = document.getElementById('lp-wizard-submit');

    if (!form) return;

    var totalSteps = 4;
    var currentStep = 1;

    // ── Pre-Qualifier (Step 1: Pflegegrad) ──
    // 3 große Buttons (Ja / Nein / Unklar) → bei "Ja" Detail-Picker (PG 1-5),
    // bei "Nein"/"Unklar" direkt weiter zu Step 2.
    var pgValue = document.getElementById('lp-pg-value');
    var pgDetailValue = document.getElementById('lp-pg-detail-value');
    var pgDetailBox = document.getElementById('lp-pg-detail');
    var pqBtns = form.querySelectorAll('.lp-prequal__btn');
    var pqDetailBtns = form.querySelectorAll('.lp-prequal__detail-btn');

    pqBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pqBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var val = btn.getAttribute('data-pg') || '';
        if (pgValue) pgValue.value = val;
        if (val === 'ja') {
          // Detail einblenden
          if (pgDetailBox) pgDetailBox.hidden = false;
        } else {
          // Detail ausblenden + Detail-Wert leeren
          if (pgDetailBox) pgDetailBox.hidden = true;
          if (pgDetailValue) pgDetailValue.value = '';
          pqDetailBtns.forEach(function (b) { b.classList.remove('is-active'); });
          // Direkt weiter
          setTimeout(function () { if (currentStep === 1) goToStep(currentStep + 1); }, 280);
        }
      });
    });

    pqDetailBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pqDetailBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (pgDetailValue) pgDetailValue.value = btn.getAttribute('data-pg-detail') || '';
        setTimeout(function () { if (currentStep === 1) goToStep(currentStep + 1); }, 280);
      });
    });

    btnNext.addEventListener('click', function () {
      if (validateStep(currentStep)) {
        goToStep(currentStep + 1);
      }
    });

    btnBack.addEventListener('click', function () {
      goToStep(currentStep - 1);
    });

    // ── Webhook-Konfiguration ──
    // URL wird über window.LUADA_LEAD_CONFIG.webhookUrl aus Liquid gesetzt.
    var WEBHOOK_URL = (window.LUADA_LEAD_CONFIG && window.LUADA_LEAD_CONFIG.webhookUrl) || '';

    function hasWebhookPlaceholders(value) {
      return !value || value.indexOf('%%') !== -1;
    }

    function isValidWebhookUrl(value) {
      return /^https?:\/\//i.test(value || '');
    }

    function isWebhookConfigured() {
      return isValidWebhookUrl(WEBHOOK_URL) && !hasWebhookPlaceholders(WEBHOOK_URL);
    }

    // ── Meta CAPI Hilfsfunktionen ──
    function lpGetCookie(name) {
      return document.cookie.split('; ').reduce(function (r, v) {
        var p = v.split('=');
        return p[0] === name ? decodeURIComponent(p[1]) : r;
      }, '');
    }

    function lpGetUtmParams() {
      var params = {};
      try {
        var sp = new URLSearchParams(location.search);
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'].forEach(function (k) {
          var v = sp.get(k);
          if (v) {
            params[k] = v;
            try { sessionStorage.setItem('lp_notrufuhr_' + k, v); } catch (e) {}
          }
        });
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'].forEach(function (k) {
          if (!params[k]) {
            try { var c = sessionStorage.getItem('lp_notrufuhr_' + k); if (c) params[k] = c; } catch (e) {}
          }
        });
      } catch (e) {}
      return params;
    }

    function lpGenerateEventId() {
      try {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
          return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
        });
      } catch (e) {
        return Math.random().toString(36).slice(2) + Date.now().toString(36);
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateStep(currentStep)) return;

      btnSubmit.disabled = true;
      btnSubmit.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="lp-spin"><circle cx="12" cy="12" r="10" opacity="0.25"/><path d="M12 2a10 10 0 0 1 10 10"/></svg> Wird gesendet…';

      // Collect form data
      var formData = new FormData(form);
      var data = {};
      formData.forEach(function (value, key) {
        if (key === '_hp') return; // Honeypot nicht senden
        if (data[key]) {
          if (Array.isArray(data[key])) {
            data[key].push(value);
          } else {
            data[key] = [data[key], value];
          }
        } else {
          data[key] = value;
        }
      });

      data._source = 'landing-notrufuhr';
      data.source = 'landing-notrufuhr'; // Webhook erwartet data.source (ohne Underscore)

      // ── Meta CAPI Felder anhängen (für webhook.luada.de/lead → CAPI Lead Event) ──
      var utms = lpGetUtmParams();
      var eventId = lpGenerateEventId();
      data.fbc = lpGetCookie('_fbc') || '';
      data.fbp = lpGetCookie('_fbp') || '';
      data.fbclid = utms.fbclid || '';
      data.utm_source = utms.utm_source || '';
      data.utm_medium = utms.utm_medium || '';
      data.utm_campaign = utms.utm_campaign || '';
      data.utm_content = utms.utm_content || '';
      data.utm_term = utms.utm_term || '';
      data.event_id = eventId;
      data.page_url = location.href;
      data.referrer = document.referrer || '';
      data.ts = new Date().toISOString();

      // Browser-Pixel (falls verfügbar – vor dem Async-Fetch feuern für zuverlässigeres Tracking)
      try {
        if (window.fbq) {
          window.fbq('track', 'Lead', { content_name: 'landing-notrufuhr' }, { eventID: eventId });
        }
      } catch (e) {}

      // Event-ID für sessionStorage speichern (z. B. für spätere Danke-Seite)
      try { sessionStorage.setItem('lp_notrufuhr_event_id', eventId); } catch (e) {}

      // Primär: eigener Webhook (wenn konfiguriert), sonst Shopify-Fallback
      sendLead(data)
        .then(function (result) {
          form.style.display = 'none';
          document.querySelector('.lp-wizard__progress').style.display = 'none';
          document.querySelector('.lp-wizard__step-indicator').style.display = 'none';
          if (successEl) {
            successEl.style.display = 'block';
          }
        })
        .catch(function (err) {
          console.error('Webhook error:', err);
          btnSubmit.disabled = false;
          btnSubmit.innerHTML = 'Persönliche Empfehlung kostenlos anfordern <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>';
          showStepError(currentStep, 'Es gab ein Problem beim Senden. Bitte versuchen Sie es erneut.');
        });
    });

    function sendLead(data) {
      if (isWebhookConfigured()) {
        return sendToWebhook(data).catch(function (err) {
          // Wenn der Webhook temporär fehlschlägt, versuchen wir den Shopify-Fallback.
          return sendToShopifyContact(data);
        });
      }

      // Ohne gültige Webhook-Konfiguration nicht hart fehlschlagen.
      return sendToShopifyContact(data);
    }

    // ── JSON-Fetch zum eigenen Webhook ──
    function sendToWebhook(data) {
      return fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (body) {
              throw new Error(body.error || 'Server-Fehler ' + response.status);
            });
          }
          return response.json();
        });
    }

    function sendToShopifyContact(data) {
      var kontakte = data.notfall_kontakt;
      if (Array.isArray(kontakte)) {
        kontakte = kontakte.join(', ');
      }

      var bodyText = [
        'Quelle: Landingpage Notrufuhr',
        'Notfallkontakt: ' + (kontakte || '-'),
        'Pflegegrad: ' + (data.pflegegrad || '-'),
        'Beziehung: ' + (data.rolle || '-'),
        'Telefon: ' + (data.phone || '-'),
      ].join('\n');

      var formBody = new URLSearchParams();
      formBody.append('form_type', 'contact');
      formBody.append('utf8', '✓');
      formBody.append('contact[first_name]', data.vorname || '');
      formBody.append('contact[last_name]', data.nachname || '');
      formBody.append('contact[email]', data.email || '');
      formBody.append('contact[phone]', data.phone || '');
      formBody.append('contact[body]', bodyText);

      return fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: formBody.toString(),
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Kontaktformular konnte nicht gesendet werden (' + response.status + ')');
        }
        return { ok: true, channel: 'shopify-contact' };
      });
    }

    function goToStep(step) {
      if (step < 1 || step > totalSteps) return;

      // Hide current
      var currentEl = form.querySelector('.lp-wizard__step[data-step="' + currentStep + '"]');
      if (currentEl) {
        currentEl.hidden = true;
        currentEl.classList.remove('lp-wizard__step--active');
      }

      currentStep = step;

      // Show new step
      var nextEl = form.querySelector('.lp-wizard__step[data-step="' + currentStep + '"]');
      if (nextEl) {
        nextEl.hidden = false;
        nextEl.classList.add('lp-wizard__step--active');
      }

      // Update progress
      var pct = (currentStep / totalSteps) * 100;
      if (progressBar) progressBar.style.width = pct + '%';
      if (currentIndicator) currentIndicator.textContent = currentStep;

      // Back button visibility
      btnBack.style.visibility = currentStep > 1 ? 'visible' : 'hidden';

      // Next vs Submit
      if (currentStep === totalSteps) {
        btnNext.style.display = 'none';
        btnSubmit.style.display = 'flex';
      } else {
        btnNext.style.display = 'inline-flex';
        btnSubmit.style.display = 'none';
      }

      // Scroll form card top into view on mobile
      if (window.innerWidth <= 767) {
        var formCard = form.closest('.lp-hero__form-card');
        if (formCard) {
          setTimeout(function () {
            var top = formCard.getBoundingClientRect().top + window.pageYOffset - 10;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }, 100);
        }
      }
    }

    function validateStep(step) {
      clearErrors();

      switch (step) {
        case 1: {
          // Step 1 NEU: Pflegegrad (Pre-Qualifier)
          var pgVal = (pgValue && pgValue.value) || '';
          if (!pgVal) {
            showStepError(step, 'Bitte wählen Sie eine Option (Ja / Nein / Unklar).');
            return false;
          }
          if (pgVal === 'ja' && pgDetailValue && !pgDetailValue.value) {
            showStepError(step, 'Bitte wählen Sie zusätzlich den Pflegegrad (1–5).');
            return false;
          }
          return true;
        }
        case 2: {
          // Step 2 NEU: Notfallkontakt
          var checked = form.querySelectorAll('input[name="notfall_kontakt"]:checked');
          if (checked.length === 0) {
            showStepError(step, 'Bitte wählen Sie mindestens eine Option.');
            return false;
          }
          return true;
        }
        case 3: {
          var valid = true;
          var vorname = form.querySelector('#lp-vorname');
          var nachname = form.querySelector('#lp-nachname');
          var rolle = form.querySelector('#lp-rolle');

          if (vorname && !vorname.value.trim()) { showFieldError(vorname, 'Bitte Vorname eingeben.'); valid = false; }
          if (nachname && !nachname.value.trim()) { showFieldError(nachname, 'Bitte Nachname eingeben.'); valid = false; }
          if (rolle && (!rolle.value || rolle.value === '')) { showFieldError(rolle, 'Bitte Beziehung wählen.'); valid = false; }

          return valid;
        }
        case 4: {
          var valid = true;
          var email = form.querySelector('#lp-email');
          var phone = form.querySelector('#lp-phone');
          var legal = form.querySelector('#lp-legal');

          if (email && (!email.value.trim() || !isValidEmail(email.value))) { showFieldError(email, 'Bitte gültige E-Mail eingeben.'); valid = false; }
          if (phone && !phone.value.trim()) { showFieldError(phone, 'Bitte Rufnummer eingeben.'); valid = false; }
          if (legal && !legal.checked) { showFieldError(legal, 'Bitte Datenschutzerklärung akzeptieren.'); valid = false; }

          return valid;
        }
        default:
          return true;
      }
    }

    function showStepError(step, message) {
      var stepEl = form.querySelector('.lp-wizard__step[data-step="' + step + '"]');
      if (!stepEl) return;
      var existing = stepEl.querySelector('.lp-form__error');
      if (existing) existing.remove();
      var errorEl = document.createElement('p');
      errorEl.className = 'lp-form__error';
      errorEl.textContent = message;
      errorEl.style.marginTop = '8px';
      stepEl.appendChild(errorEl);
    }

    function showFieldError(input, message) {
      input.classList.add('lp-form__input-error');
      var errorEl = document.createElement('span');
      errorEl.className = 'lp-form__error';
      errorEl.textContent = message;
      input.parentNode.appendChild(errorEl);
    }

    function clearErrors() {
      form.querySelectorAll('.lp-form__error').forEach(function (el) { el.remove(); });
      form.querySelectorAll('.lp-form__input-error').forEach(function (el) { el.classList.remove('lp-form__input-error'); });
    }

    function isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
  }

  /* ===== STICKY CTA LOGIC ===== */
  function initStickyCta() {
    var stickyCta = document.getElementById('lp-sticky-cta');
    var heroSection = document.getElementById('lp-hero');
    var leadForm = document.getElementById('lp-lead-form');
    var stickyBtn = stickyCta ? stickyCta.querySelector('.lp-sticky-cta__btn') : null;

    if (!stickyCta || !heroSection) return;

    var heroInView = true;
    var formInView = false;

    function setStickyVisible(visible) {
      stickyCta.style.transform = visible ? 'translateY(0)' : 'translateY(100%)';
      stickyCta.style.pointerEvents = visible ? 'auto' : 'none';
    }

    function updateStickyVisibility() {
      // Never show sticky CTA while user is within hero or interacting with the lead form.
      var shouldShow = !heroInView && !formInView;
      setStickyVisible(shouldShow);
    }

    function isInViewport(el, buffer) {
      if (!el) return false;
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return rect.bottom > (buffer || 0) && rect.top < (vh - (buffer || 0));
    }

    function updateByScrollPosition() {
      heroInView = isInViewport(heroSection, 20);
      formInView = leadForm ? isInViewport(leadForm, 20) : false;
      updateStickyVisibility();
    }

    var observer = null;
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === heroSection) {
            heroInView = entry.isIntersecting;
          }
          if (leadForm && entry.target === leadForm) {
            formInView = entry.isIntersecting;
          }
        });
        updateStickyVisibility();
      }, { threshold: 0.1 });
    }

    stickyCta.style.transition = 'transform 0.3s ease';
    setStickyVisible(false);

    if (observer) {
      observer.observe(heroSection);
      if (leadForm) observer.observe(leadForm);
    }

    // Fallback + robustness for mobile browsers where IntersectionObserver behaves inconsistently.
    window.addEventListener('scroll', updateByScrollPosition, { passive: true });
    window.addEventListener('resize', updateByScrollPosition);
    updateByScrollPosition();

    // Ensure sticky CTA always scrolls reliably to the form card.
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = leadForm;
        var card = leadForm ? leadForm.closest('.lp-hero__form-card') : null;
        if (card) target = card;
        if (!target) return;

        var top = target.getBoundingClientRect().top + window.pageYOffset - 10;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }
  }

  /* ===== SMOOTH SCROLL FÜR ANCHOR LINKS ===== */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#lp-"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = link.getAttribute('href');
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          // For #lp-lead-form, scroll to the parent form card so header is visible
          var scrollTarget = target;
          if (targetId === '#lp-lead-form') {
            var card = target.closest('.lp-hero__form-card');
            if (card) scrollTarget = card;
          }
          var headerOffset = 10;
          var elementPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: elementPosition - headerOffset,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /* ===== INTERSECTION OBSERVER FÜR SCROLL-ANIMATIONEN ===== */
  function initScrollAnimations() {
    var animatedElements = document.querySelectorAll(
      '.lp-features__card, .lp-pricing__card, .lp-steps__item, .lp-faq__item'
    );

    if (!animatedElements.length || !('IntersectionObserver' in window)) return;

    animatedElements.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animatedElements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ===== INIT ===== */
  function init() {
    initTabs();
    initWizard();
    initStickyCta();
    initSmoothScroll();
    initScrollAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
